import React, { useEffect } from 'react';
import {
  DetailsRoutesWrapper,
  DetailsWrapper,
  HorizontalLine,
  POCHeading,
  Root,
  StudentDetails,
  StudentIdHeading,
  StudentNameHeading,
  POCValue,
} from '../student-details/styled-comps';
import { FlexView, Row, COLORS } from '@cuemath/comps';
import { useParams, useLocation } from 'react-router-dom';
import { useCSMGet } from '../../api/csm';
import { Text, Separator } from '@cuemath/web-comps';
import CopyButton from 'comps/copy-button';
import LAYOUT from 'constants/layout';
import { CSM_TAB_MENU } from 'comps/tab-menu/tabs';
import { parse } from 'query-string';
import styled from 'styled-components';
import { getUserFullName } from 'utils';

const POCValueWrapper = styled.div`
  overflow-wrap: break-word;
`;
const POCValueText = styled(POCValue)`
  text-transform: none;
`;
const POCHeadingWrapper = styled(POCHeading)`
  margin-bottom: 8px;
`;

const CsmDetails = () => {
  const location = useLocation();
  const { search } = location;
  const { csmId } = useParams();
  const { activeTab } = parse(search);

  const tab = CSM_TAB_MENU.find(({ path }) => (activeTab ? path === activeTab : true));
  const { Component } = tab ?? {};
  const { data: csmDetails, get: getCsmDetails, isProcessing, isProcessed } = useCSMGet();
  const { first_name: fName = '', last_name: lName = '', id, email } = csmDetails ?? {};

  useEffect(() => {
    if (csmId && !isProcessing && !isProcessed) {
      getCsmDetails(csmId);
    }
  }, [csmId]);

  return (
    <Root>
      <DetailsWrapper>
        <StudentDetails>
          <Row justifyContent="space-between" alignItems="flex-start">
            <StudentNameHeading variant="h5">
              {getUserFullName(fName, lName)}
            </StudentNameHeading>
          </Row>
          <Separator height={24} />
          <FlexView>
            <POCHeadingWrapper variant="eyebrow2">Email</POCHeadingWrapper>
            <POCValueWrapper>
              <POCValueText variant="cta1">{email ?? '-'}</POCValueText>
            </POCValueWrapper>
          </FlexView>
          <Separator height={12} />
          <HorizontalLine marginTop="4px" />
          <FlexView>
            <StudentIdHeading justifyContent="space-between">
              <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
                CSM ID
              </Text>
            </StudentIdHeading>
            <CopyButton copyMessage="Copy CSM ID" text={id} />
          </FlexView>
          <Separator height={LAYOUT.GUTTER} />
        </StudentDetails>
      </DetailsWrapper>
      <DetailsRoutesWrapper>
        <Component />
      </DetailsRoutesWrapper>
    </Root>
  );
};

export default CsmDetails;
